import React from "react";

import Messages from "./Messages";

import { Row, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const MessagesPage = () => {
  document.title = "Messages | Clued.in Cloest Admin";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Clued.in Closet" breadcrumbItem="Messages" />
          <Row className="mb-4">
            <Messages />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MessagesPage;
